import Vue from 'vue'
// import { store } from './store/_store.js'

import SlimUploader from './components/SlimUploader.vue'
import StoreInit from './components/StoreInit.vue'

// END GLOBAL COMPONENT IMPORT

var app = new Vue({
	el: '#app',
	data: {
		items: []
	},
	// store,
	components: {
		SlimUploader,
		StoreInit,
	},
});